import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader-mod/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"back\"><defs><style></style></defs><path d=\"M363.84 472.979c-26.901 24.38-26.538 64.507.89 88.507l309.222 270.569c8.867 7.759 22.344 6.86 30.103-2.007s6.86-22.344-2.007-30.103L392.827 529.376c-8.231-7.202-8.325-17.54-.335-24.782l309.834-280.786c8.73-7.912 9.394-21.403 1.482-30.134-7.912-8.73-21.403-9.394-30.134-1.482L363.841 472.98z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol